import React from 'react';

export const CrownIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M5 16L3 5L8.5 10L12 4L15.5 10L21 5L19 16H5Z"
            fill="currentColor"
        />
        <path
            d="M5 16H19V18H5V16Z"
            fill="currentColor"
        />
    </svg>
);
